/**
 * Security Wizard — security-wizard.js
 * 3-step lead-generation wizard for Jump.ca Home Security.
 * Reads all configuration from window.SECURITY_CONFIG (populated by Liquid).
 */
(function () {
  'use strict';

  var CONFIG = window.SECURITY_CONFIG;
  if (!CONFIG) {
    console.error('Security Wizard: SECURITY_CONFIG not found');
    return;
  }

  var SCENARIOS = CONFIG.scenarios || [];
  var DEVICES = CONFIG.devices || {};
  var SETTINGS = CONFIG.settings || {};
  var SECTION_ID = CONFIG.sectionId || '';

  /* ---- SKIP STEP 2 FLAG ----
   * Set to true to skip the Customize step (Step 2).
   * When ready to re-enable Step 2, set this to false and
   * restore the progress bar items in security-bundle-cta.liquid.
   */
  var SKIP_STEP2 = true;

  /* ---- Build INCLUDED map from device data ---- */
  var INCLUDED = {};
  getAllDevices().forEach(function (d) {
    INCLUDED[d.id] = d.includedQty || 0;
  });

  /* ---- STATE ---- */
  var chosen = null;
  var qty = {};
  var activeTab = 'cameras';
  var currentStep = 1;

  /* ---- DOM CACHE ---- */
  var DOM = {};

  /* ---- HELPERS ---- */
  function getAllDevices() {
    return [].concat(DEVICES.cameras || [], DEVICES.smart || [], DEVICES.additional || []);
  }

  function getDevice(id) {
    return getAllDevices().find(function (d) { return d.id === id; });
  }

  function calcExtra() {
    var total = 0;
    getAllDevices().forEach(function (d) {
      var q = qty[d.id] || 0;
      var inc = INCLUDED[d.id] || 0;
      total += Math.max(0, q - inc) * d.price;
    });
    return total;
  }

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str || '';
    return d.innerHTML;
  }

  function formatPrice(val) {
    var num = parseFloat(val);
    if (isNaN(num)) return '0.00';
    return num % 1 === 0 ? num.toFixed(0) : num.toFixed(2);
  }

  function scrollToTop() {
    var wrapper = document.getElementById('SecurityWizard-' + SECTION_ID);
    if (wrapper) {
      var modalBody = wrapper.closest('.sw-builder-modal-body');
      if (modalBody) {
        modalBody.scrollTop = 0;
      } else {
        window.scrollTo(0, 0);
      }
    }
  }

  /* ---- SVG ICON FALLBACKS ---- */
  var DEVICE_ICONS = {
    doorbell: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M18 8h1a4 4 0 0 1 0 8h-1"/><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"/><line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/></svg>',
    outdoor: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M23 7 16 12 23 17V7z"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>',
    indoor: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="12" cy="13" r="3"/><path d="M5 7H3a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2l-2-3H9L7 7z"/></svg>',
    controlPanel: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>',
    windowDoor: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
    motion: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>',
    smoke: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/></svg>',
    co: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"/></svg>',
    flood: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/></svg>',
    glassBreak: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>'
  };

  function getDeviceIcon(deviceId) {
    return DEVICE_ICONS[deviceId] || '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/></svg>';
  }

  /* ---- SCENARIO SVG ILLUSTRATIONS ---- */
  function scenarioSVG(s) {
    var c = s.color || '#00aa90';
    if (s.id === 'simply') return '<svg width="140" height="120" viewBox="0 0 140 120" fill="none"><path d="M70 18L116 52H24L70 18Z" fill="' + c + '" fill-opacity=".3"/><rect x="30" y="52" width="80" height="54" rx="4" fill="' + c + '" fill-opacity=".15"/><rect x="56" y="74" width="28" height="32" rx="3" fill="' + c + '" fill-opacity=".4"/><rect x="36" y="58" width="18" height="16" rx="2" fill="' + c + '" fill-opacity=".5"/><rect x="86" y="58" width="18" height="16" rx="2" fill="' + c + '" fill-opacity=".5"/><circle cx="102" cy="38" r="16" fill="' + c + '" fill-opacity=".12"/><rect x="94" y="31" width="16" height="14" rx="3" stroke="' + c + '" stroke-width="1.8" fill="none"/><path d="M98 31V28a4 4 0 0 1 8 0v3" stroke="' + c + '" stroke-width="1.8" stroke-linecap="round" fill="none"/><circle cx="102" cy="37" r="2" fill="' + c + '" fill-opacity=".8"/></svg>';
    if (s.id === 'family') return '<svg width="140" height="120" viewBox="0 0 140 120" fill="none"><path d="M70 16L116 50H24L70 16Z" fill="' + c + '" fill-opacity=".3"/><rect x="30" y="50" width="80" height="54" rx="4" fill="' + c + '" fill-opacity=".15"/><rect x="56" y="72" width="28" height="32" rx="3" fill="' + c + '" fill-opacity=".38"/><circle cx="40" cy="63" r="7" fill="' + c + '" fill-opacity=".55"/><path d="M33 78C33 74 47 74 47 78" stroke="' + c + '" stroke-width="2" stroke-linecap="round" fill="none"/><circle cx="100" cy="65" r="6" fill="' + c + '" fill-opacity=".55"/><path d="M94 79C94 75.5 106 75.5 106 79" stroke="' + c + '" stroke-width="2" stroke-linecap="round" fill="none"/><circle cx="70" cy="59" r="5" fill="' + c + '" fill-opacity=".7"/><path d="M65 70C65 67 75 67 75 70" stroke="' + c + '" stroke-width="2" stroke-linecap="round" fill="none"/><path d="M108 30C104 26 98 26 98 32C98 38 108 44 108 44C108 44 118 38 118 32C118 26 112 26 108 30Z" fill="' + c + '" fill-opacity=".4"/></svg>';
    return '<svg width="140" height="120" viewBox="0 0 140 120" fill="none"><path d="M70 16L116 50H24L70 16Z" fill="' + c + '" fill-opacity=".28"/><rect x="30" y="50" width="80" height="54" rx="4" fill="' + c + '" fill-opacity=".13"/><rect x="56" y="72" width="28" height="32" rx="3" fill="' + c + '" fill-opacity=".38"/><circle cx="70" cy="50" r="5" fill="' + c + '" fill-opacity=".7"/><line x1="70" y1="45" x2="70" y2="30" stroke="' + c + '" stroke-width="1.5" stroke-dasharray="3 2" stroke-opacity=".5"/><line x1="70" y1="30" x2="96" y2="30" stroke="' + c + '" stroke-width="1.5" stroke-opacity=".5"/><circle cx="96" cy="30" r="4" fill="' + c + '" fill-opacity=".65"/><line x1="70" y1="30" x2="44" y2="30" stroke="' + c + '" stroke-width="1.5" stroke-opacity=".5"/><circle cx="44" cy="30" r="4" fill="' + c + '" fill-opacity=".65"/><rect x="112" y="52" width="12" height="9" rx="2" fill="' + c + '" fill-opacity=".45"/><rect x="16" y="52" width="12" height="9" rx="2" fill="' + c + '" fill-opacity=".45"/><path d="M70 63 78 67V74C78 79 70 81 70 81C70 81 62 79 62 74V67L70 63Z" stroke="' + c + '" stroke-width="1.8" fill="' + c + '" fill-opacity=".18"/><circle cx="115" cy="22" r="10" fill="' + c + '" fill-opacity=".12"/><polyline points="110,22 113,25 120,18" stroke="' + c + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>';
  }

  /* ==================================================================
     NAVIGATION
     ================================================================== */
  function goToStep(n) {
    if (n === 2 && !chosen) return;
    if (n === 3 && SKIP_STEP2 && !chosen) return;
    currentStep = n;

    // Toggle step visibility
    var wrapper = document.getElementById('SecurityWizard-' + SECTION_ID);
    if (!wrapper) return;
    var steps = wrapper.querySelectorAll('.sw-step');
    steps.forEach(function (el) { el.classList.remove('sw-step-on'); });
    var target = wrapper.querySelector('[data-sw-step="' + n + '"]');
    if (target) target.classList.add('sw-step-on');

    // Update progress bar
    [1, 2, 3].forEach(function (i) {
      var num = wrapper.querySelector('[data-sw-pnum="' + i + '"]');
      var lbl = wrapper.querySelector('[data-sw-plbl="' + i + '"]');
      if (!num || !lbl) return;
      num.className = 'sw-progress-num';
      lbl.className = 'sw-progress-lbl';
      if (SKIP_STEP2) {
        // 2-step mode: step 1 = pnum 1, step 3 = pnum 3
        if (i === 1) {
          if (n === 1) { num.classList.add('sw-active'); lbl.classList.add('sw-active'); }
          else { num.classList.add('sw-done'); lbl.classList.add('sw-done'); }
        }
        if (i === 3) {
          if (n >= 3) { num.classList.add('sw-active'); lbl.classList.add('sw-active'); }
        }
      } else {
        if (i < n) { num.classList.add('sw-done'); lbl.classList.add('sw-done'); }
        else if (i === n) { num.classList.add('sw-active'); lbl.classList.add('sw-active'); }
      }
    });

    // Render step content
    if (n === 2) { renderDeviceGrid(); switchTabActive('cameras'); }
    if (n === 3) renderSummary();

    scrollToTop();
  }

  /* ==================================================================
     STEP 1 — SCENARIOS
     ================================================================== */
  function renderScenarios() {
    var grid = DOM.scenarioGrid;
    if (!grid) return;

    grid.innerHTML = SCENARIOS.map(function (s) {
      var isSel = chosen && chosen.id === s.id;
      var selStyle = isSel ? 'outline-color:' + s.color + ';' : '';
      var heroContent = s.heroImage
        ? '<img src="' + esc(s.heroImage) + '" alt="' + esc(s.name) + '">'
        : scenarioSVG(s);
      var highlights = (s.highlights || []).filter(Boolean).map(function (h) {
        return '<div class="sw-sc-hl-item"><div class="sw-sc-dot" style="background:' + esc(s.color) + ';"></div>' + esc(h) + '</div>';
      }).join('');

      var overlayHtml = s.overlay && s.overlayColor
        ? '<div class="sw-sc-overlay" style="background:' + esc(s.overlayColor) + ';opacity:' + (s.overlayOpacity || 0.3) + ';"></div>'
        : '';

      return '<div class="sw-sc-card' + (isSel ? ' sw-sel' : '') + '" data-scenario-id="' + esc(s.id) + '" style="' + selStyle + '">' +
        '<div class="sw-sc-hero" style="background:' + esc(s.bgLight) + ';">' +
          heroContent +
          overlayHtml +
          '<div class="sw-sc-check" style="background:' + esc(s.color) + ';">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg>' +
          '</div>' +
        '</div>' +
        '<div class="sw-sc-body">' +
          '<div class="sw-sc-persona">' + esc(s.persona) + '</div>' +
          '<div class="sw-sc-name">' + esc(s.name) + '</div>' +
          '<div class="sw-sc-tagline" style="color:' + esc(s.color) + ';">' + esc(s.tagline) + '</div>' +
          '<div class="sw-sc-story">' + esc(s.story) + '</div>' +
          '<div class="sw-sc-hl">' + highlights + '</div>' +
          (s.basePrice > 0 ? '<div class="sw-sc-price">Starting at <span style="color:' + esc(s.color) + ';">$' + formatPrice(s.basePrice) + '</span>/mo</div>' : '') +
          '<div class="sw-sc-btn" style="' + (isSel ? 'background:' + s.color + ';color:#fff;' : '') + '">' +
            (isSel ? '&#10003; Selected' : 'Select This Plan') +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  function pickScenario(id) {
    chosen = SCENARIOS.find(function (s) { return s.id === id; });
    if (!chosen) return;
    qty = {};
    // Copy default quantities from scenario
    var quantities = chosen.quantities || {};
    Object.keys(quantities).forEach(function (key) {
      qty[key] = quantities[key];
    });
    if (DOM.btnNext1) DOM.btnNext1.disabled = false;
    renderScenarios();
  }

  /* ==================================================================
     STEP 2 — DEVICE BUILDER
     ================================================================== */
  function switchTabActive(tab) {
    activeTab = tab;
    var wrapper = document.getElementById('SecurityWizard-' + SECTION_ID);
    if (!wrapper) return;

    wrapper.querySelectorAll('.sw-tab-btn').forEach(function (btn) {
      btn.classList.toggle('sw-on', btn.getAttribute('data-sw-tab') === tab);
    });

    var tabConfig = SETTINGS.step2 && SETTINGS.step2.tabs ? SETTINGS.step2.tabs[tab] : null;
    var banner = DOM.tabBanner;
    if (banner && tabConfig) {
      banner.className = 'sw-info-bar sw-' + (tabConfig.bannerStyle || 'green');
      banner.textContent = tabConfig.banner || '';
    }

    renderDeviceGrid();
  }

  function renderDeviceGrid() {
    if (chosen && DOM.step2Sub) {
      var template = (SETTINGS.step2 && SETTINGS.step2.subtitleTemplate) || 'Starting with the {plan} package.';
      DOM.step2Sub.innerHTML = template.replace('{plan}', '<strong>' + esc(chosen.name) + '</strong>');
    }

    var devs = DEVICES[activeTab] || [];
    var grid = DOM.deviceGrid;
    if (!grid) return;

    grid.innerHTML = devs.map(function (d) {
      var q = qty[d.id] || 0;
      var inc = INCLUDED[d.id] || 0;
      var isOn = q > 0;
      var iconContent = d.image
        ? '<img src="' + esc(d.image) + '" alt="' + esc(d.label) + '">'
        : getDeviceIcon(d.id);

      var qtyControl = d.locked
        ? '<div class="sw-qty-locked">Included in every plan</div>'
        : '<div class="sw-qty-wrap">' +
            '<button class="sw-qty-btn" data-sw-qty-change="' + esc(d.id) + '" data-sw-delta="-1"' + (q <= 0 ? ' disabled' : '') + '>&#8722;</button>' +
            '<div class="sw-qty-val">' + q + '</div>' +
            '<button class="sw-qty-btn" data-sw-qty-change="' + esc(d.id) + '" data-sw-delta="1"' + (q >= d.max ? ' disabled' : '') + '>&#43;</button>' +
          '</div>';

      return '<div class="sw-dev-card' + (isOn ? ' sw-on' : '') + '" data-sw-device-id="' + esc(d.id) + '">' +
        '<div class="sw-dev-top">' +
          '<div class="sw-dev-info">' +
            '<div class="sw-dev-name">' + esc(d.label) + '</div>' +
            '<div class="sw-dev-desc">' + esc(d.desc) + '</div>' +
            (d.detailDesc ? '<div class="sw-dev-details-link" data-sw-modal="' + esc(d.id) + '">View Details &rsaquo;</div>' : '') +
          '</div>' +
          '<div class="sw-dev-ico ' + (isOn ? 'sw-ico-on' : 'sw-ico-off') + '">' + iconContent + '</div>' +
        '</div>' +
        '<div class="sw-dev-price-row">' +
          '<div class="sw-dev-price">' + (d.price === 0 ? 'Included' : '$' + formatPrice(d.price) + '/mo') + '</div>' +
          (inc > 0 ? '<div class="sw-incl-badge">' + inc + ' included</div>' : '') +
        '</div>' +
        qtyControl +
      '</div>';
    }).join('');

    // Update sticky bar prices
    var extra = calcExtra();
    var base = chosen ? (chosen.basePrice || 0) : 0;
    if (DOM.sbarTotal) {
      DOM.sbarTotal.textContent = '$' + formatPrice(base + extra);
    }
    if (DOM.sbarBase) {
      DOM.sbarBase.textContent = '$' + formatPrice(base);
    }
    if (DOM.sbarPrice) {
      DOM.sbarPrice.textContent = '+$' + extra.toFixed(2);
    }
  }

  function changeQuantity(deviceId, delta) {
    var d = getDevice(deviceId);
    if (!d || d.locked) return;
    qty[deviceId] = Math.max(0, Math.min(d.max, (qty[deviceId] || 0) + delta));
    renderDeviceGrid();
  }

  /* ==================================================================
     DEVICE DETAIL MODAL
     ================================================================== */
  function openDeviceModal(deviceId) {
    var d = getDevice(deviceId);
    if (!d) return;

    var overlay = DOM.modalOverlay;
    if (!overlay) return;

    // Title
    var title = overlay.querySelector('.sw-modal-title');
    if (title) title.textContent = d.label;

    // Image
    var imageWrap = overlay.querySelector('.sw-modal-image-wrap');
    if (imageWrap) {
      imageWrap.innerHTML = d.image
        ? '<img src="' + esc(d.image) + '" alt="' + esc(d.label) + '">'
        : '<div style="color:var(--sw-teal);">' + getDeviceIcon(d.id).replace('width="24"', 'width="64"').replace('height="24"', 'height="64"') + '</div>';
    }

    // Description
    var desc = overlay.querySelector('.sw-modal-desc-text');
    if (desc) desc.textContent = d.detailDesc || d.desc || '';

    // Specs
    var specsWrap = overlay.querySelector('.sw-modal-specs');
    if (specsWrap) {
      var specs = (d.specs || []).filter(function (s) { return s && s.label; });
      specsWrap.innerHTML = specs.map(function (s) {
        return '<div class="sw-modal-spec-row">' +
          '<div class="sw-modal-spec-label">' + esc(s.label) + '</div>' +
          '<div class="sw-modal-spec-value">' + esc(s.value) + '</div>' +
        '</div>';
      }).join('');
    }

    // Price
    var priceEl = overlay.querySelector('.sw-modal-price');
    if (priceEl) {
      priceEl.textContent = d.price === 0 ? 'Included' : '+$' + formatPrice(d.price) + '/mo';
    }

    // Quantity control
    var qtyWrap = overlay.querySelector('.sw-modal-qty');
    if (qtyWrap) {
      var q = qty[d.id] || 0;
      if (d.locked) {
        qtyWrap.innerHTML = '<div class="sw-qty-locked">Included in every plan</div>';
      } else {
        qtyWrap.innerHTML =
          '<div class="sw-qty-wrap">' +
            '<button class="sw-qty-btn" data-sw-modal-qty="' + esc(d.id) + '" data-sw-delta="-1"' + (q <= 0 ? ' disabled' : '') + '>&#8722;</button>' +
            '<div class="sw-qty-val">' + q + '</div>' +
            '<button class="sw-qty-btn" data-sw-modal-qty="' + esc(d.id) + '" data-sw-delta="1"' + (q >= d.max ? ' disabled' : '') + '>&#43;</button>' +
          '</div>';
      }
    }

    // Store current device ID for modal qty updates
    overlay.setAttribute('data-sw-modal-device', deviceId);

    // Show overlay
    overlay.classList.add('sw-modal-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDeviceModal() {
    var overlay = DOM.modalOverlay;
    if (!overlay) return;
    overlay.classList.remove('sw-modal-open');
    overlay.setAttribute('aria-hidden', 'true');
    // Only restore body scroll if builder modal is not open
    var builderModal = document.getElementById('securityBuilderModal');
    if (!builderModal || builderModal.style.display === 'none') {
      document.body.style.overflow = '';
    }
    renderDeviceGrid();
  }

  /* ==================================================================
     STEP 3 — SUMMARY
     ================================================================== */
  function renderSummary() {
    if (!chosen) return;
    var wrapper = document.getElementById('SecurityWizard-' + SECTION_ID);
    if (!wrapper) return;

    // Plan name
    var planNameEl = DOM.sumPlanName;
    if (planNameEl) planNameEl.textContent = (chosen.name || '') + ' Package';

    // Base price
    var base = chosen.basePrice || 0;
    var extra = calcExtra();
    if (DOM.sumBase) {
      DOM.sumBase.textContent = '$' + formatPrice(base);
    }

    // Price display — when SKIP_STEP2, show only base with "Starting at"
    var estLbl = wrapper.querySelector('.sw-sum-est-lbl');
    var estNote = wrapper.querySelector('.sw-sum-est-note');
    var bdToggle = wrapper.querySelector('.sw-sum-bd-toggle');
    var bdPanel = wrapper.querySelector('.sw-sum-bd-panel');

    if (SKIP_STEP2) {
      if (DOM.sumEstVal) DOM.sumEstVal.textContent = '$' + formatPrice(base);
      if (estLbl) estLbl.textContent = 'Starting at';
      if (estNote) estNote.textContent = 'Final pricing confirmed by your advisor.';
      if (bdToggle) bdToggle.style.display = 'none';
      if (bdPanel) { bdPanel.style.display = 'none'; bdPanel.classList.remove('sw-open'); }
    } else {
      if (DOM.sumEstVal) DOM.sumEstVal.textContent = '$' + formatPrice(base + extra);
      if (estLbl) estLbl.textContent = 'Est. Monthly Total';
      if (estNote) estNote.textContent = 'Includes bundle + device add-ons. Final pricing confirmed by your advisor.';
      if (bdToggle) bdToggle.style.display = '';
      if (bdPanel) bdPanel.style.display = '';
    }

    // Hidden total (for form submission)
    var totalEl = DOM.sumTotal;
    if (totalEl) totalEl.textContent = (extra).toFixed(2);

    // Pre-populate Package Interest dropdown with chosen package
    var pkgSelect = wrapper.querySelector('#sw-f-package');
    if (pkgSelect && chosen) {
      var pkgName = chosen.name || '';
      for (var i = 0; i < pkgSelect.options.length; i++) {
        if (pkgSelect.options[i].value === pkgName) {
          pkgSelect.value = pkgName;
          break;
        }
      }
    }

    // Breakdown: split items into included vs paid
    var items = getAllDevices().filter(function (d) { return (qty[d.id] || 0) > 0; });
    var includedItems = [];
    var addonItems = [];
    items.forEach(function (d) {
      var q = qty[d.id];
      var inc = INCLUDED[d.id] || 0;
      var extraQty = Math.max(0, q - inc);
      var cost = extraQty * d.price;
      var row = '<div class="sw-sum-item">' +
        '<div><span class="sw-sum-item-name">' + esc(d.label) + '</span><span class="sw-sum-item-qty">&times;' + q + '</span></div>' +
        '<div class="sw-sum-item-cost ' + (cost > 0 ? 'sw-paid' : 'sw-free') + '">' +
          (cost > 0 ? '+$' + cost.toFixed(2) + '/mo' : 'Included') +
        '</div>' +
      '</div>';
      if (cost === 0) {
        includedItems.push(row);
      } else {
        addonItems.push(row);
      }
    });

    var inclEl = wrapper.querySelector('.sw-sum-bd-included');
    if (inclEl) inclEl.innerHTML = includedItems.length ? includedItems.join('') : '<div class="sw-sum-item"><div class="sw-sum-item-name" style="color:var(--sw-muted);">None</div></div>';

    var addEl = wrapper.querySelector('.sw-sum-bd-addons');
    if (addEl) addEl.innerHTML = addonItems.length ? addonItems.join('') : '<div class="sw-sum-item"><div style="color:var(--sw-muted);">No add-ons selected</div></div>';
  }

  /* ==================================================================
     FORM SUBMISSION
     ================================================================== */
  function buildDeviceSummaryText() {
    var lines = [];
    lines.push('Package: ' + (chosen ? chosen.name : 'None'));
    lines.push('Devices:');
    getAllDevices().forEach(function (d) {
      var q = qty[d.id] || 0;
      if (q <= 0) return;
      var inc = INCLUDED[d.id] || 0;
      var extra = Math.max(0, q - inc);
      var cost = extra * d.price;
      var suffix = cost > 0 ? ' (+$' + cost.toFixed(2) + '/mo)' : ' (included)';
      lines.push('  - ' + d.label + ' x' + q + suffix);
    });
    lines.push('Base Monitoring: $' + formatPrice(chosen ? chosen.basePrice || 0 : 0) + '/mo');
    lines.push('Monthly Device Add-ons: +$' + calcExtra().toFixed(2) + '/mo');
    return lines.join('\n');
  }

  var submitInFlight = false;

  function handleSubmit(e) {
    // Re-entry / double-submit guard.
    if (submitInFlight) { if (e) e.preventDefault(); return; }

    var nameVal = DOM.formName ? DOM.formName.value.trim() : '';
    var phoneVal = DOM.formPhone ? DOM.formPhone.value.trim() : '';
    var emailVal = DOM.formEmail ? DOM.formEmail.value.trim() : '';

    // Validation — block the native submit if the essentials are missing.
    if (!nameVal || !phoneVal || !emailVal) {
      if (e) e.preventDefault();
      var errorEl = DOM.formError;
      if (errorEl) {
        errorEl.textContent = 'Please enter your name, phone number, and email so we can reach you.';
        errorEl.classList.add('sw-visible');
      }
      return;
    }

    var form = DOM.contactForm;
    if (!form) {
      if (e) e.preventDefault();
      showError();
      return;
    }

    // Reference number (for the email) + hidden field payload.
    var refNum = 'JSC-' + (Math.floor(10000 + Math.random() * 90000));
    if (DOM.hiddenPackage) DOM.hiddenPackage.value = (chosen ? chosen.name : '') + ' Package';
    // Step 2 (device customization) is hidden for now, so submit only the plan
    // and its base monitoring price — no device list or add-on total.
    if (DOM.hiddenPrice) DOM.hiddenPrice.value = '$' + formatPrice(chosen ? chosen.basePrice || 0 : 0) + '/mo';
    if (DOM.hiddenRef) DOM.hiddenRef.value = refNum;

    // Commit: block re-entry, disable the button. We do NOT preventDefault —
    // the NATIVE submit proceeds so Shopify's CAPTCHA runs its supported flow,
    // the email sends, and Shopify redirects back to this page with
    // ?contact_posted=true (handled on load to show the thank-you). AJAX and
    // hidden-iframe approaches both fail here (400 "Missing CAPTCHA token" and
    // the site's frame-ancestors CSP, respectively), so native submit it is.
    submitInFlight = true;
    if (DOM.submitBtn) {
      DOM.submitBtn.disabled = true;
      DOM.submitBtn.textContent = 'Submitting...';
    }

    // Safety net: if the page doesn't navigate (e.g., the user closes the
    // captcha challenge), re-enable the button so they can retry.
    setTimeout(function () {
      submitInFlight = false;
      if (DOM.submitBtn) {
        DOM.submitBtn.disabled = false;
        DOM.submitBtn.textContent = 'Submit & Get a Quote';
      }
    }, 45000);
  }

  /* After a successful native submit, Shopify redirects back here with
     ?contact_posted=true. Re-open the wizard straight to the thank-you screen. */
  function maybeShowThankYou() {
    if (window.location.search.indexOf('contact_posted=true') === -1) return;
    // Clean the URL so a later refresh doesn't re-trigger the thank-you.
    try { history.replaceState(null, '', window.location.pathname); } catch (e) {}
    if (typeof window.openSecurityBuilder === 'function') window.openSecurityBuilder();
    showSuccess(''); // no reference number to show on a fresh page load
  }

  function showSuccess(refNum) {
    var wrapper = document.getElementById('SecurityWizard-' + SECTION_ID);
    if (!wrapper) return;

    // Update success content. Hide the reference tag when there's no number
    // (post-redirect thank-you), otherwise show it.
    if (DOM.refNumber) DOM.refNumber.textContent = refNum || '';
    var refTag = wrapper.querySelector('.sw-ref-tag');
    if (refTag) refTag.style.display = refNum ? '' : 'none';

    // Show success step
    wrapper.querySelectorAll('.sw-step').forEach(function (el) { el.classList.remove('sw-step-on'); });
    var successStep = wrapper.querySelector('[data-sw-step="success"]');
    if (successStep) successStep.classList.add('sw-step-on');

    // Update progress bar — all done
    [1, 2, 3].forEach(function (i) {
      var num = wrapper.querySelector('[data-sw-pnum="' + i + '"]');
      var lbl = wrapper.querySelector('[data-sw-plbl="' + i + '"]');
      if (num) { num.className = 'sw-progress-num sw-done'; }
      if (lbl) { lbl.className = 'sw-progress-lbl sw-done'; }
    });

    scrollToTop();
  }

  /* Graceful failure — shown when the submission genuinely does not go through.
     Re-enables the button so the customer can retry, and points them to the
     phone number instead of silently pretending it succeeded. */
  function showError() {
    var wrapper = document.getElementById('SecurityWizard-' + SECTION_ID);

    // Allow another attempt.
    submitInFlight = false;

    // Always re-enable the submit button so a retry is possible.
    if (DOM.submitBtn) {
      DOM.submitBtn.disabled = false;
      DOM.submitBtn.textContent = 'Submit & Get a Quote';
    }

    if (wrapper) {
      var errorStep = wrapper.querySelector('[data-sw-step="error"]');
      if (errorStep) {
        wrapper.querySelectorAll('.sw-step').forEach(function (el) { el.classList.remove('sw-step-on'); });
        errorStep.classList.add('sw-step-on');
        scrollToTop();
        return;
      }
    }

    // Fallback if the error screen markup isn't present: inline message.
    if (DOM.formError) {
      DOM.formError.textContent = 'Sorry — we could not send your request just now. Please try again'
        + (CONFIG.phone ? ', or call us at ' + CONFIG.phone : '') + '.';
      DOM.formError.classList.add('sw-visible');
    }
  }

  /* ==================================================================
     EVENT DELEGATION
     ================================================================== */
  function bindEvents() {
    var wrapper = document.getElementById('SecurityWizard-' + SECTION_ID);
    if (!wrapper) return;

    // Scenario card clicks
    wrapper.addEventListener('click', function (e) {
      // Scenario selection
      var scenarioCard = e.target.closest('[data-scenario-id]');
      if (scenarioCard && scenarioCard.closest('.sw-sc-grid')) {
        pickScenario(scenarioCard.getAttribute('data-scenario-id'));
        return;
      }

      // Tab switching
      var tabBtn = e.target.closest('[data-sw-tab]');
      if (tabBtn) {
        switchTabActive(tabBtn.getAttribute('data-sw-tab'));
        return;
      }

      // Quantity change (main grid)
      var qtyBtn = e.target.closest('[data-sw-qty-change]');
      if (qtyBtn) {
        e.stopPropagation();
        changeQuantity(
          qtyBtn.getAttribute('data-sw-qty-change'),
          parseInt(qtyBtn.getAttribute('data-sw-delta'), 10)
        );
        return;
      }

      // Quantity change (modal)
      var modalQtyBtn = e.target.closest('[data-sw-modal-qty]');
      if (modalQtyBtn) {
        e.stopPropagation();
        var devId = modalQtyBtn.getAttribute('data-sw-modal-qty');
        var delta = parseInt(modalQtyBtn.getAttribute('data-sw-delta'), 10);
        changeQuantity(devId, delta);
        // Re-render modal qty
        openDeviceModal(devId);
        return;
      }

      // Device detail modal open
      var detailLink = e.target.closest('[data-sw-modal]');
      if (detailLink) {
        e.stopPropagation();
        openDeviceModal(detailLink.getAttribute('data-sw-modal'));
        return;
      }

      // Device card click opens modal (only if device has detail desc)
      var devCard = e.target.closest('.sw-dev-card');
      if (devCard && !e.target.closest('.sw-qty-wrap')) {
        var cardDevId = devCard.getAttribute('data-sw-device-id');
        var cardDev = getDevice(cardDevId);
        if (cardDev && cardDev.detailDesc) {
          openDeviceModal(cardDevId);
          return;
        }
      }

      // Modal close
      if (e.target.closest('.sw-modal-close') || e.target.closest('.sw-modal-backdrop') || e.target.closest('.sw-modal-done-btn')) {
        closeDeviceModal();
        return;
      }

      // Breakdown toggles (sticky bar + summary)
      var breakdownBtn = e.target.closest('[data-sw-breakdown]') || e.target.closest('[data-sw-sum-breakdown]');
      if (breakdownBtn) {
        breakdownBtn.classList.toggle('sw-open');
        var isSummary = breakdownBtn.hasAttribute('data-sw-sum-breakdown');
        if (isSummary) {
          var panel = wrapper.querySelector('.sw-sum-bd-panel');
          if (panel) panel.classList.toggle('sw-open');
        } else {
          var bd = breakdownBtn.nextElementSibling;
          if (bd) bd.classList.toggle('sw-open');
        }
        return;
      }

      // Navigation buttons
      var backBtn = e.target.closest('[data-sw-back]');
      if (backBtn) {
        goToStep(parseInt(backBtn.getAttribute('data-sw-back'), 10));
        return;
      }

      var nextBtn = e.target.closest('[data-sw-next]');
      if (nextBtn) {
        goToStep(parseInt(nextBtn.getAttribute('data-sw-next'), 10));
        return;
      }

      // Next button (step 1)
      if (e.target.closest('#sw-btn-next1-' + SECTION_ID)) {
        goToStep(SKIP_STEP2 ? 3 : 2);
        return;
      }

    });

    // The submit button lives outside the <form> but is wired to it via the
    // button's form="SecurityWizardForm" attribute, so a click (or Enter) fires
    // the form's native submit event — which we handle here.
    if (DOM.contactForm) {
      DOM.contactForm.addEventListener('submit', handleSubmit);
    }

    // Escape key closes modals (device detail first, then builder)
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (DOM.modalOverlay && DOM.modalOverlay.classList.contains('sw-modal-open')) {
          closeDeviceModal();
          return;
        }
        var builderModal = document.getElementById('securityBuilderModal');
        if (builderModal && builderModal.style.display !== 'none') {
          window.closeSecurityBuilder();
        }
      }
    });
  }

  /* ==================================================================
     INIT
     ================================================================== */
  function init() {
    var wrapper = document.getElementById('SecurityWizard-' + SECTION_ID);
    if (!wrapper) return;

    // Cache DOM elements
    DOM.scenarioGrid = wrapper.querySelector('.sw-sc-grid');
    DOM.btnNext1 = wrapper.querySelector('#sw-btn-next1-' + SECTION_ID);
    DOM.deviceGrid = wrapper.querySelector('.sw-dev-grid');
    DOM.tabBanner = wrapper.querySelector('.sw-info-bar');
    DOM.step2Sub = wrapper.querySelector('.sw-step2-sub');
    DOM.sbarTotal = wrapper.querySelector('.sw-sbar-total-val');
    DOM.sbarPrice = wrapper.querySelector('.sw-sbar-price-val');
    DOM.sbarBase = wrapper.querySelector('.sw-sbar-base-val');
    DOM.modalOverlay = wrapper.querySelector('.sw-modal-overlay');
    DOM.sumPlanName = wrapper.querySelector('.sw-sum-hdr-title');
    DOM.sumItems = wrapper.querySelector('.sw-sum-body');
    DOM.sumTotal = wrapper.querySelector('.sw-sum-total-val');
    DOM.sumBase = wrapper.querySelector('.sw-sum-base-val');
    DOM.sumEstVal = wrapper.querySelector('.sw-sum-est-val');
    DOM.sumNote = wrapper.querySelector('.sw-sum-note');
    DOM.contactForm = wrapper.querySelector('#SecurityWizardForm');
    DOM.formName = wrapper.querySelector('#sw-f-name');
    DOM.formPhone = wrapper.querySelector('#sw-f-phone');
    DOM.formEmail = wrapper.querySelector('#sw-f-email');
    DOM.formError = wrapper.querySelector('.sw-form-error');
    DOM.hiddenPackage = wrapper.querySelector('#sw-hidden-package');
    DOM.hiddenPrice = wrapper.querySelector('#sw-hidden-price');
    DOM.hiddenRef = wrapper.querySelector('#sw-hidden-ref');
    DOM.submitBtn = wrapper.querySelector('.sw-submit-btn');
    DOM.refNumber = wrapper.querySelector('.sw-ref-num');

    // Render initial state
    renderScenarios();
    bindEvents();
    maybeShowThankYou();
  }

  /* ==================================================================
     BUILDER MODAL OPEN / CLOSE
     ================================================================== */
  window.openSecurityBuilder = function () {
    var modal = document.getElementById('securityBuilderModal');
    if (modal) {
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      document.body.classList.add('security-builder-active');
      // Scroll modal body to top
      var body = modal.querySelector('.sw-builder-modal-body');
      if (body) body.scrollTop = 0;
    }
  };

  window.closeSecurityBuilder = function () {
    var modal = document.getElementById('securityBuilderModal');
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
      document.body.classList.remove('security-builder-active');
    }
  };

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
